import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const NewCustomMetricBox = ({ onCreate }) => {
  const handleClickCreate = (key) => {
    onCreate?.(key);
  };

  return (
    <Button size="small" icon={<PlusOutlined />} onClick={() => handleClickCreate('metric')}>
      Custom Metric
    </Button>
  );
};

export default NewCustomMetricBox;
